import { Component } from '@angular/core';

import { PuiAppSettings } from '../../../core/index';

@Component({
  templateUrl: 'not-found.component.html'
})
export class PuiPageNotFoundComponent {
  defaultUrl = PuiAppSettings.defaultUrl;
}
